import { queryRepairList,insertRepair,urgeRepair,finishRepair,queryMaintainList,insertMaintain,deleteMaintain } from "../../api/config/modules/MaintainManagement";

const state = {
    queryRepairList: {},
    insertRepair: {},
    urgeRepair: {},
    finishRepair: {},
    queryMaintainList: {},
    insertMaintain: {},
    deleteMaintain: {},
};

const mutations = {
  SET_QUERYREPAIRLIST: (state, queryRepairList) => {
    state.queryRepairList = queryRepairList;
  },
  SET_INSERTREPAIR: (state, insertRepair) => {
    state.insertRepair = insertRepair;
  },
  SET_URGEREPAIR: (state, urgeRepair) => {
    state.urgeRepair = urgeRepair;
  },
  SET_FINISHREPAIR: (state, finishRepair) => {
    state.finishRepair = finishRepair;
  },
  SET_QUERYMAINTAINLIST: (state, queryMaintainList) => {
    state.queryMaintainList = queryMaintainList;
  },
  SET_INSERTMAINTAIN: (state, insertMaintain) => {
    state.insertMaintain = insertMaintain;
  },
  SET_DELETEMAINTAIN: (state, deleteMaintain) => {
    state.deleteMaintain = deleteMaintain;
  },
};

const actions = {
  GET_QUERYREPAIRLIST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        queryRepairList(data)
        .then((res) => {
          commit("SET_QUERYREPAIRLIST", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_INSERTREPAIR: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        insertRepair(data)
        .then((res) => {
          commit("SET_INSERTREPAIR", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_URGEREPAIR: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      urgeRepair(data)
        .then((res) => {
          commit("SET_URGEREPAIR", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_FINISHREPAIR: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      finishRepair(data)
        .then((res) => {
          commit("SET_FINISHREPAIR", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_QUERYMAINTAINLIST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        queryMaintainList(data)
        .then((res) => {
          commit("SET_QUERYMAINTAINLIST", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_INSERTMAINTAIN: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        insertMaintain(data)
        .then((res) => {
          commit("SET_INSERTMAINTAIN", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_DELETEMAINTAIN: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        deleteMaintain(data)
        .then((res) => {
          commit("SET_DELETEMAINTAIN", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
